import { useEffect } from 'react';

export const useHandleClickOutside = (
  ref: React.RefObject<HTMLElement>,
  callback: () => void,
  timeout: number = 100
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        // Use timeout to ensure all events have completed
        setTimeout(() => {
          callback();
        }, timeout);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback, timeout]);
};
